import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import showConfirmModal from '../../Modal/ConfirmModal/ConfirmModal.action'
import { updatePassword } from '../Auth.actions'
import ChangePasswordFormComponent from './ChangePasswordForm'

const formName = 'changePasswordForm'

const stateToProps = ({ auth: { passwordUpdateLoading } }) => ({
  passwordUpdateLoading,
})

const dispatchToProps = {
  showConfirmModal,
  updatePassword,
}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    form: formName,
  })(ChangePasswordFormComponent)
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/ChangePasswordForm/ChangePasswordForm.container.js